<template>
	<div class="comp">
		<el-dialog :title="title" :visible.sync="dialogState" width="500px" :close-on-click-modal="false">
			<el-form :model="form" ref="form" :inline="true" style="padding-top:0px;">
				<el-row>
					<el-col :span="24">
						<el-form-item label="顾客：" :label-width="formLabelWidth">
							{{bingliMsg.memberName}} ( {{bingliMsg.memberMobile}} )
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="顾客：" :label-width="formLabelWidth">
							{{bingliMsg.petName}} ( {{bingliMsg.typeName}} )
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="住院服务：" :label-width="formLabelWidth">
							<el-button v-if="$public.isNull(skuItem.service_objectId)" @click="open_dialogAddShop" style="width:260px;" size="small">添加住院服务项</el-button>
							<div v-else @click="open_dialogAddShop" style="cursor: pointer;">{{goodsItem.title}} {{skuItem.service_objectName}}</div>
							 
							
							<!-- <el-select style="width:260px" v-model="form.curServiceIndex" @change="changeZhuyuan" placeholder="请选择">
								<div>
									<el-option v-for="(item,index) in zhuyuanList" :key="index" :label="item.basic_info.product_name"
									:value="index">
									</el-option>
								</div>
							</el-select> -->
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="住院单价：" :label-width="formLabelWidth">
							<el-input :value="form.sale_price+' 元/天'" disabled style="width:260px" size="small"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="离院时间：" :label-width="formLabelWidth">
							<!-- <el-date-picker style="width:560px" v-model="form.timeRange" type="daterange" :picker-options="{disabledDate(time) {return time.getTime() < new Date(new Date().getTime()-86400000)}}" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
							</el-date-picker> -->
							<el-date-picker style="width:260px" v-model="form.timeRange" type="date" size="small" :picker-options="{disabledDate(time) {return time.getTime() < new Date(new Date().getTime())}}" :clearable="false">
							</el-date-picker>
							<div style="color:red">（住院开始时间默认为今天）</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" >
						<el-form-item label="住院房间：" :label-width="formLabelWidth" >
							
							<div>{{ form.cageInfo.positionName }}{{ form.cageInfo.cageName }}
				<el-button type="warning" @click="addPetCage()" size="mini" style="margin-left:20px;">+选择</el-button></div>
	
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="押金类型：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.depositType" @change="changeRadio" size="small">
								<el-radio :label="1">押金</el-radio>
								<el-radio :label="2">余额</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="押金：" :label-width="formLabelWidth">
							<el-input v-model="form.deposit" :disabled="form.depositType==2" style="width:260px" placeholder="请输入金额" clearable size="small">
								<template slot="append">元</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" v-if="form.depositType==1">
						<el-form-item label="支付方式：" :label-width="formLabelWidth">
							<el-select style="width:260px;" v-model="form.payType" clearable placeholder="请选择" size="small">
								<el-option v-for="(item) in [{value:0,label:'现金'},{value:3,label:'线下支付宝'},{value:4,label:'线下微信'},{value:5,label:'pos'}]" :key="item.label" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="经办人：" :label-width="formLabelWidth">
							<el-select style="width:260px;" v-model="form.doctorIndex" clearable placeholder="请选择" size="small">
								<el-option v-for="(item,index) in doctorList" :key="item._id" :label="item.basic_info.nick_name" :value="index">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="备注：" :label-width="formLabelWidth">
							<el-input type="textarea" v-model="form.remark" :rows="4" style="width:260px" placeholder="请输入备注" clearable size="small"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 添加套餐 -->
		<div v-if="dialogAddShop_state">
			<dialogAddShop :addShopState="dialogAddShop_state" :classType="'0'" :shopId="curShopId" :tree="[{id:'601d11cfa93f55b5cf3ae2eb',children:[{id:'601d11d0a93f55b5cf3ae2fe'}]}]" @closeOn="dialogAddShop_state=false" @submit="submit_dialogAddShop"></dialogAddShop>
		</div>
		<div v-if="petCageState">
        <drawerZhuyuanPetCage
          :petId="petId"
		  :apply_type="apply_type"
          @submit="submit_drawerStatus"
        ></drawerZhuyuanPetCage>
      </div>
	</div>
</template>
<script>
	import dialogAddShop from "./dialog_addShop.vue"
	import drawerZhuyuanPetCage from "./drawerPetCage/drawer_ZhuyuanPetCage.vue";
	export default {
		components:{dialogAddShop,drawerZhuyuanPetCage},
		data() {
			return {
				dialogState:true,
				title:'新建住院',
				formLabelWidth: '100px',
				userInfo:{card_info:{}},
				zhuyuanList:[],
				doctorList:[],
				form:{
					curServiceIndex:'',
					timeRange:'',
					depositType:1, // (1现金；2余额)
					deposit:'',    // number
					sale_price:0,
					payType:'',    //
					doctorIndex:'',
					remark:'',
					cageInfo:{
						    positionId:'',
							positionName:"",
							cageId:'',
							cageName:''
					}
				},
				// 商品套餐
				dialogAddShop_state:false,
				curPackage:{},
				// 服务
				goodsItem:'',
				skuItem:'',
				  // 宠物笼子
				  petCageState: false,
				  petId:"",
				  apply_type:'', //猫狗分类
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		props:{
			bingliMsg:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			dialogState(n){
				this.$emit('close',n)
			}
		},
		mounted() {
			// this.$util.getZhuyuanList().then(list=>{
			// 	this.zhuyuanList = list;
			// })
			this.$util.getDoctorList().then(list=>{
				this.doctorList = list;
			})
			this.$util.getUserInfo(this.bingliMsg.memberId).then(res=>{
				this.userInfo = res;
			})
		},
		methods: {
			submit_drawerStatus(obj) {
				console.log(obj,"obj住院");
				this.form.cageInfo.positionId=obj.positionId
				this.form.cageInfo.positionName=obj.positionName
				this.form.cageInfo.cageId=obj.cageId
				this.form.cageInfo.cageName=obj.cageName
                this.petCageState = false;
                },
	      // 选择住院笼子
	       addPetCage(){
			 this.apply_type=this.bingliMsg.petType
			   this.petId=this.bingliMsg.petId
				this.petCageState = true;
			},
			cancel(){
				this.$emit("submit")
			},
			submit(){
				let loading = this.$loading()
				if(this.$public.isNull(this.skuItem.service_objectId)){
					this.$message({
						message: '请选择住院服务！',
						type: 'error'
					});
					loading.close()
					return ;
				}
				if(this.form.doctorIndex===''){
					this.$message({
						message: '请选择经办人！',
						type: 'error'
					});
					loading.close()
					return ;
				}
				if(this.form.depositType===1){
					if(this.form.deposit==''){
						this.$message({
							message: '请输入押金！',
							type: 'error'
						});
						loading.close()
						return ;
					}
					if(this.form.payType===''){
						this.$message({
							message: '请选择押金支付方式！',
							type: 'error'
						});
						loading.close()
						return ;
					}
					if(!this.form.cageInfo.positionId){
						this.$message({
							message: '请选择住院的笼子！',
							type: 'error'
						});
						loading.close()
						return ;
					}
				}
				if(this.form.sale_price>this.form.deposit){
					this.$message({
						message: (this.form.depositType===2?'余额':'押金')+'应大于住院单价！',
						type: 'error'
					});
					loading.close()
					return ;
				}
				let params = {
					"caseNumber": this.bingliMsg.caseNumber,
					"memberId":	this.bingliMsg.memberId,
					"memberName":this.bingliMsg.memberName,
					"memberMobile":	this.bingliMsg.memberMobile,
					"contactName":	this.bingliMsg.contactName,
					"contactMobile": this.bingliMsg.contactMobile,
					"petId": this.bingliMsg.petId,
					"petName": this.bingliMsg.petName,
					"typeName": this.bingliMsg.typeName,
					"sex": this.bingliMsg.sex,
					"birthDay": this.bingliMsg.birthDay,
					// "productId": this.zhuyuanList[this.form.curServiceIndex]._id,
					// "productName": this.zhuyuanList[this.form.curServiceIndex].basic_info.product_name,
					"productId": this.goodsItem.serviceId,
					"productName": this.goodsItem.title,
					"productObjectId": this.skuItem.service_objectId,
					"productObjectName": this.skuItem.service_objectName,
					// categoryId: this.goodsItem.category_info._id,  // 洋洋自己能拿到
					// categoryName: this.goodsItem.category_info.name,
					"beginDate": "",
					"endDate": "",
					"depositType": this.form.depositType,
					"deposit": Number(this.form.deposit),
					"payType": Number(this.form.payType),
					"handlerId": this.doctorList[this.form.doctorIndex]._id,
					"handlerName": this.doctorList[this.form.doctorIndex].basic_info.nick_name,
					"remark": this.form.remark,
					"cageInfo":this.form.cageInfo,
					classType:Number(this.bingliMsg.petType)
				}
				console.log(this.bingliMsg.petType,"this.bingliMsg.petTypeclassType",params);
				// if(this.form.timeRange&&this.form.timeRange.length==2){
				// 	params.beginDate = new Date(this.form.timeRange[0]).getTime().toString().substr(0,10);
				// 	params.endDate = new Date(this.form.timeRange[1]).getTime().toString().substr(0,10);
				// }
				if(this.form.timeRange){
					params.beginDate = '';
					params.endDate = new Date(this.form.timeRange).getTime().toString().substr(0,10);
				}
				else{
					this.$message({
						message: '住院时间不能为空！',
						type: 'error'
					});
					loading.close()
					return ;
				}
				console.log(params,"this.bingliMsg.petTypeparams")
				this.$http.post('/api/InHospital/Insert', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit("submit",res.data)
					}
				})
			},
			changeAge(){
				let month = parseInt(Number(this.ageYear||0)*12+Number(this.ageMonth||0));
				this.datePickerValue = this.$public.FBirthday(month)
			},
			changeRadio(i){
				if(i===1){
					this.form.deposit = '';
					this.form.payType = '';
				}else{
					this.form.deposit = this.userInfo.card_info.user_yue
					this.form.payType = ''
				}
			},
			// changeZhuyuan(index){
			// 	this.form.sale_price = this.zhuyuanList[index].basic_info.price.sale_price;
			// },
			// 套餐
			open_dialogAddShop(){
				this.dialogAddShop_state = true;
			},
			submit_dialogAddShop({goodsItem,skuItem,wayItem,goodsType}){
				console.log(goodsItem,skuItem,wayItem,goodsType)
				this.goodsItem = goodsItem;
				this.skuItem = skuItem;
				this.dialogAddShop_state = false;
				this.form.sale_price = skuItem.price;
			},
			changeDatePicker(d){
				let a = this.$public.FAge(d);
				this.ageYear = a[0];
				this.ageMonth = a[1];
			},
			// 选择性别
			changeSex(a){
				this.form.sex = a[0];
				this.form.sterilization = a[1];
			},
			// 修改宠物品种
			changeType(str){
				this.form.type_name=str;
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		::v-deep .el-dialog__body{
			padding: 10px 20px;
			.el-form-item{
				margin-bottom:10px;
			}
		}
	}
</style>
